import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["badge"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState } from 'react';
import { useQueryClient } from 'react-query';
import { useUpdatePlaylistBadge } from 'actions/badges';
import { useAddPlaylist } from 'actions/playlists';
import playlistKeys from 'actions/playlists/queryKeys';
import { formatPlaylistEditorPayloadForApi } from '../utils/formatPlaylistEditorPayloadForApi';
export function useSubmitPlaylistCreator(_ref) {
  var ownerTeamId = _ref.ownerTeamId,
    onSuccess = _ref.onSuccess,
    selectedTopicId = _ref.selectedTopicId;
  var queryClient = useQueryClient();
  var _useAddPlaylist = useAddPlaylist(ownerTeamId),
    addPlaylist = _useAddPlaylist.addPlaylist;
  var _useUpdatePlaylistBad = useUpdatePlaylistBadge(),
    updatePlaylistBadge = _useUpdatePlaylistBad.updatePlaylistBadge;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmissionLoading = _useState2[0],
    setIsSubmissionLoading = _useState2[1];
  function submitPlaylistCreation(_x) {
    return _submitPlaylistCreation.apply(this, arguments);
  }
  function _submitPlaylistCreation() {
    _submitPlaylistCreation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
      var newBadgeData, playlistChanges, formattedChanges, newPlaylistData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsSubmissionLoading(true);
            newBadgeData = payload.badge, playlistChanges = _objectWithoutProperties(payload, _excluded);
            formattedChanges = formatPlaylistEditorPayloadForApi(playlistChanges);
            _context.prev = 3;
            _context.next = 6;
            return addPlaylist(_objectSpread(_objectSpread({}, formattedChanges), {}, {
              ownerTeamId: Number(ownerTeamId),
              selectedTopicId: selectedTopicId
            }));
          case 6:
            newPlaylistData = _context.sent;
            if (!newBadgeData) {
              _context.next = 10;
              break;
            }
            _context.next = 10;
            return updatePlaylistBadge({
              contentId: newPlaylistData.id,
              imageId: newBadgeData.imageId
            });
          case 10:
            _context.next = 12;
            return queryClient.invalidateQueries(playlistKeys.playlistList());
          case 12:
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(newPlaylistData.id, newPlaylistData.index);
            setIsSubmissionLoading(false);
            _context.next = 19;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](3);
            setIsSubmissionLoading(false);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 16]]);
    }));
    return _submitPlaylistCreation.apply(this, arguments);
  }
  return {
    submitPlaylistCreation: submitPlaylistCreation,
    isSubmissionLoading: isSubmissionLoading
  };
}